<script setup lang="ts">
import Spin from '@components/spin/index.vue'
import { assign } from 'lodash-es'
import systemNoticeContent from './components/modal-set/system-notice-content.vue'
import type { Notice } from './api/system'
import { SystemService } from './api/system'
import type { NoticeReadOptions } from './components/modal-set/types'
import { NoticeReadStatus } from './components/modal-set/types'
import { LOGIN_SUCCESS, SHOW_NEW_NOTICE } from './constant/event-name-key'
import { JsonParse } from './utils/object-tools'
import { useSpinning } from './composables/use-spinning'
import { loadStorage } from './utils/cache'
import { NOTICE_READ_STATUS } from './constant/cache-key'
import useArcoLang from '@/composables/use-arco-lang'
import useModal from '@/composables/use-modal'
import store from '@/store'

defineOptions({ name: 'App' })
const { locale } = useArcoLang()
const { on, off } = store.evenStore
const { user } = storeToRefs(store.authStore)

const { openModal, closeModal } = useModal()
const modalId = 'notice-modal'
function openNoticeModal(notice: Notice) {
  openModal({
    hideTitle: true,
    width: 660,
    closable: false,
    escToClose: false,
    maskClosable: false,
    content: () => h(systemNoticeContent, {
      notice,
      onClose: () => {
        closeModal(modalId)
      },
    }),
  }, modalId)
}

const { setGlobalSpinning } = useSpinning()
async function getLatestNotice(options: { isCheck: boolean }) {
  try {
    setGlobalSpinning(true)
    const { data } = await SystemService.getLatestNotice({ status: NoticeReadStatus.OPEN })
    const cacheKey = `${data?.id ?? ''}-${user.value.current_enterprise}-${user.value.user_id}`
    const readdNotices = loadStorage<Record<string, NoticeReadOptions>>(NOTICE_READ_STATUS, {})
    const currentIsRead = readdNotices[cacheKey]?.read
    // 1、登录系统时自动触发查询是否有最新公告，如果有且未读则弹窗提示 isCheck = true 登录时检查
    // 2、点击悬浮按钮查看最新公告时，则弹窗提示，不校验是否已读 isCheck = false 点击悬浮按钮查询时
    if (data && data.id && (!options.isCheck || (options.isCheck && !currentIsRead))) {
      const notice = assign({}, data, { content: typeof data.content === 'string' ? JsonParse(data.content) : data.content })
      openNoticeModal(notice)
    }
  }
  catch (error) {
    console.error(error)
  }
  finally {
    setGlobalSpinning(false)
  }
}

onMounted(() => {
  on(LOGIN_SUCCESS, getLatestNotice)
  on(SHOW_NEW_NOTICE, getLatestNotice)
})

onUnmounted(() => {
  off(LOGIN_SUCCESS, getLatestNotice)
  off(SHOW_NEW_NOTICE, getLatestNotice)
})
</script>

<template>
  <!-- <a-config-provider :locale="locale">
    <a-layout class="h-full">
      <a-layout-header>
        <PCHeader />
      </a-layout-header>
      <a-layout-content class="overflow-auto bg-light-bg dark:bg-dark-bg">
        <RouterView />
      </a-layout-content>
    </a-layout>
  </a-config-provider> -->
  <a-config-provider :locale="locale">
    <Spin class="size-full" scope="globalSpinning">
      <RouterView />
    </Spin>
  </a-config-provider>
</template>

<style scoped>
</style>
